module.exports = __webpack_public_path__ + "media/images/icons/pocitoveMapyW-cc68198145dac91ca69b2c39b6db589c.svg";